import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Cookies from 'js-cookie'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import { initializeAuth } from './utils/auth'

// Get CSRF token from cookies
const csrftoken = Cookies.get('csrftoken');

if (csrftoken) {
  axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
} else {
  console.error("CSRF token not found");
}

// Ensure credentials are sent with each request
axios.defaults.withCredentials = true;

const app = createApp(App).use(Quasar, quasarUserOptions);

app.use(router);

initializeAuth()
  .catch(() => {})
  .finally(() => {
    app.mount('#app');
  });
